/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import React, { FunctionComponent } from 'react';

import './NetworkStats.scss';

const NetworkStats: FunctionComponent = (): JSX.Element => (
    <div className="network-stats section-title disabled">No Information available!</div>
);

export default NetworkStats;
